import React from "react";
import ComingSoon from "../../../components/comingSoon/ComingSoon";
import Sidebar from "../../../components/Sidebar";

const CareerSimulationDashboard = () => (
  <Sidebar>
    <ComingSoon
      content={
        <div className="text-left font-normal text-gray-800 text-sm sm:text-base">
          <h2 className="text-lg sm:text-xl font-semibold mb-2">
            Coming Soon: Career Simulation Tool — Test Your Career Fit
          </h2>
          <p className="mb-6">Experience different career paths through our interactive simulation tool.</p>
          
          <p className="font-semibold mb-2">What It Will Do</p>
          <ul className="list-disc pl-5 space-y-4">
            <li>
              <p>
                <strong>Interactive Career Testing</strong><br />
                Simulate working in different AI-enhanced careers to see which one fits your skills and interests best.
              </p>
            </li>
            <li>
              <p>
                <strong>Real-World Scenarios</strong><br />
                Experience realistic job tasks, challenges, and day-to-day activities for various career paths.
              </p>
            </li>
            <li>
              <p>
                <strong>Skill Assessment</strong><br />
                Test your abilities in different domains and get feedback on your performance.
              </p>
            </li>
            <li>
              <p>
                <strong>Career Match Scoring</strong><br />
                Receive detailed analysis of how well you match with different career options.
              </p>
            </li>
          </ul>

          <p className="font-semibold mb-2 mt-6">Features Coming Soon</p>
          <ul className="list-disc pl-5 space-y-2">
            <li>Multiple career path simulations</li>
            <li>Interactive skill challenges</li>
            <li>Real-time feedback and scoring</li>
            <li>Detailed career compatibility reports</li>
            <li>Personalized recommendations based on performance</li>
          </ul>
        </div>
      }
    />
  </Sidebar>
);

export default CareerSimulationDashboard; 